import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cadastro-dialog-select',
  templateUrl: './cadastro-dialog.component.html',
})
export class CadastroDialogComponent implements OnInit {
  
  @Input() innerComponent:any;

  constructor(){
  }

  ngOnInit(): void {
  }

}
